import { extractAppMetadata } from './AuthenticationService';
import { DevelopmentToggles } from './LocalTogglesService';

type UserToggles = {
	[key in DevelopmentToggles]: boolean;
};

export const getUserToggles = (): UserToggles => {
	const appMetadata = extractAppMetadata();
	return appMetadata.TOGGLES || {};
};
